<template>
  <div class="login_wrap" id='loginbox'>
    <div class="top">
      <div class="title">
          <div class="title_left">
            <img src="../../assets/logo2.png" class="titleimg"  @click="gotibao">
            <!-- <div class="line"></div> -->
            <!-- <span>大数据合作平台</span> -->
          </div>
          <div class="tologin_tips">没有账号？<el-link type="primary"  @click="goregister" class="link" :underline="false">点击注册</el-link></div>
      </div>
    </div>
    <div class="bottom">
      <div class="login_wrap_in">
        <div>
          <div class="firstTxt">高效连接与匹配 全网商品与媒体</div>
          <div class="secondTxt">海量TOP创作者资源全覆盖/优质品牌及爆款商品推介/数据检测精准营销</div>
          <!-- <div class="secondTxt">内容营销者的产品文档库</div> -->
        </div>
        <div class="conent">
          <div class="login_box">
            <div class="tipsBox" v-if='loginerrer'>
              <span class="tipsImg">-</span>
              <span>手机号或密码有误</span>
            </div>
            <el-form :model="formdata1" label-width="0px" :rules="rules1" class="formdata" ref='form1'>
              <el-form-item  prop="loginTel" class="tel">
                <el-input prefix-icon="el-icon-user" type="number" v-model="formdata1.loginTel" maxlength="11" placeholder="已注册的手机号" ></el-input>
              </el-form-item>
              <el-form-item  prop="loginPassword" class="password">
                <el-input prefix-icon="el-icon-lock" type="password" v-model="formdata1.loginPassword" placeholder="请输入密码" @keyup.enter.native='keydown'></el-input>
              </el-form-item>
              <el-form-item  prop="loginImgcode" class="codeBox" v-if='loginNum >= 3'>
                <!--  -->
                <el-input type="text" prefix-icon="el-icon-key"  v-model="formdata1.loginImgcode" placeholder="请输入右侧验证码" class="code" ></el-input>
                <img class="imgcode" :src='imgcodeUrl' @click="refreshCode" ref='img'>
              </el-form-item>
            </el-form>
            <div class="forget">
              <div class="forget_l" @click="gogorgot">忘记密码？</div>
            </div>
            <el-button type="primary" class="login_btn" @click="loginHandle">登录</el-button>
          </div>
        </div> 
      </div> 
    </div>
    <foot/>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import foot from 'xingluo_components/foot.vue';
export default {
  components:{
    foot
  },
  data() {
    // 校验手机号
    let validateTel = (rule, value, callback) => {
        if(value.length > 0){
          let rex = /^1[23456789]\d{9}$/;
          if(!rex.test(value)){
            callback(new Error('手机号错误'));
          }else {
            callback()
          }
        }else {
          callback()
        }
    };
    // 校验图形验证码
    let validateImgcode = (rule, value, callback) => {
        if(value){
          let data={code: value,sid:this.$http.cookie.get('PHPSESSID')};
          this.$httplogin({
                method: 'GET',
                url: '/check',
                params: data,
            }).then((res) => {
              if(res.code == 1){
                this.n = 1;
                this.imgcode_flag = true;
                callback()
              }else {
                this.imgcode_flag = false;
                callback(new Error(res.msg));
              }
            }).catch((err) => {
                callback(new Error(res.msg));
                console.log(err);
            })
        }else {
          callback()
        }
    };
    // 校验密码
    let validatePass = (rule, value, callback) => {
       if(value.length < 6 || value.length > 24){
          callback(new Error('密码长度应为6~24位')); 
        }else {
          callback()
        }
    };
    return {
      n: 0,
      formdata1: {//登录的formdata
        loginTel:'',
        loginImgcode:'',
        loginPassword: '',
      },
      rules1:{//登录的验证规则
        // 手机号验证规则
        loginTel: [
          {
          required: true,
          message: "手机号不能为空",
          trigger:'blur'
         },
          {
          validator: validateTel,
          trigger:'blur'
        }],
        // 图形验证码规则
        loginImgcode: [
          {
          required: true,
          message: "图形验证码不能为空",
          trigger:'blur'
         },
          {
          validator: validateImgcode,
          trigger:'blur'
        }],
        // 密码验证规则
        loginPassword: [
          {
          required: true,
          message: "密码不能为空",
          trigger:'blur'
        },
          {
          validator: validatePass,
          trigger:'blur'
        }],
      },
      validateImgcode: validateImgcode,
      loginerrer:false,//是否点击登录
      imgcodeUrl: 'https://xingluoapi.linkstars.com/verify',
      loginNum: 0,
    //   address:'',
      imgcode_flag: false,
    //   routerAddress:'',
    //   entrance:'',
      login_source :'',
    };
  },
  name: 'loginpage',
  props:{
    routerAddress: String,
    // entrance: String,
    address:String,
  },
  created(){
    if(this.$route.params.register && this.$route.params.register == 'register'){
      this.login_source = 'register'
    }
  },
  mounted(){},
  methods: {
    keydown(){
       this.loginHandle()
    },
    gotibao(){
      window.location.href=`https://www.linkstars.com`;
    },
    // 去注册部分
    goregister(){
      this.$router.push({name:'registerpage'});
    },
    // 刷新验证码
    refreshCode(){
      this.$refs.img.src='https://xingluoapi.linkstars.com/verify?t='+ Math.random()
    },
    // 点击忘记密码
    gogorgot(){
      let params = ''
      if(this.address) {
        params = {
                  address:this.address,
                  pagename:1
                  // entrance:this.entrance == 'tibao' ? this.entrance: ''
                  }
      }else {
        params = {routerAddress:this.routerAddress,pagename:1}
      }
      this.$router.push({name:'forgotpassword',query:params});
    },
    // 点击登录
    loginHandle(){
      let that = this;
      if(that.n == 1) {
          that.rules1.loginImgcode = [];
      }
      that.$refs.form1.validate((valid) => {
        that.rules1.loginImgcode = [{
          required: true,
          message: "图形验证码不能为空",
          trigger:'blur'
         },
          {
          validator: that.validateImgcode,
          trigger:'blur'
        }] 
        if(valid) {
          let  data={
                tel: that.formdata1.loginTel,
                password:that.formdata1.loginPassword
              }
            that.$httplogin({
                method: 'POST',
                url: '/home/userLogin',
                data: data
            }).then((res) => {
              if(res && res.code ==1){
                that.$message({
                  message:'登录成功',
                  type: 'success'
                });
                let user_info = res.data.user_info;
                delete user_info.store_names;
                that.$http.setAuth(res.data.auth_token, user_info);  
                console.log(user_info)
                if(that.address){
                  setTimeout(()=>{//如果是从xingluo_tibao项目过来的话登录成功正常跳转回原页面
                   if(this.address == 'https://www.linkstars.com/'){
                     that.$router.push('/my/myinfo')
                   }else {
                     window.location.href=`${that.address}`;
                   }
                  },500)
                }else if(that.login_source == 'register'){//如果是从注册页面过来的话去个人中西服务页
                  that.$router.push('/my/myinfo');
                }
                else {//如果是内容合作的话登录成功要判断有没有通过审核
                  if(that.routerAddress && that.routerAddress != '/'){
                    if(that.routerAddress =='/my/myinfo'){
                      that.$router.push('/my/myinfo');
                    }else{
                      if(res.data.user_info.status == 2){//通过审核时跳转的页面
                        that.$router.push({path:that.routerAddress});                      
                      }else {//未通过审核跳转的页面
                        that.$router.push({name:'auth'})
                      }
                    } 
                  }
                  else {
                    that.$router.push('/my/myinfo');
                  }
                }
                that.loginerrer = false;
              }else {
                that.loginNum += 1 ;
                that.loginerrer = true;
                that.$message.error(res.data);
              }
            }).catch((err) => {
                console.log(err);
            }) 
        } else {
          return false
        }
      })
    }
  }



}
</script>
<style scoped>
  .top {
    height:100px;
    box-shadow:  0 2px 11px 0 rgba(215,215,215,0.50);
  }
  .title {
    width: 1190px;
    height: 100px;
    padding: 15px 0;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title_left {
    display: flex;
    align-items: center;
  }
  .line {
    width: 2px;
    height: 29px;
    background-color: #f1f1f1;
    margin: 0 15px;
  }
  .title_left span{
    font-size: 20px;
    color: #333;
  }
  .tologin_tips{
    font-size: 14px;
    color: #909399;
    display: flex;
    align-items: center;
  }
  .link {
    color: #6435E8;
  }
  .titleimg {
    width: 124px;
    cursor: pointer;
  }
  .bottom{
    background: url('../../assets/login/bgc.png') no-repeat;
    background-size: cover;
  }
  .login_wrap {
    background: #fff;
    min-height: 650px;
  }
  .login_wrap_in {
    width: 1190px;
    height: 475px;
    margin: 0 auto; 
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .firstTxt {
    font-size: 40px;
    color: #fff;
    margin-bottom: 25px;
  }
  .secondTxt {
    font-size: 20px;
    color: #fff;
    line-height: 50px;
  }
  .login_box {
    width: 425px;
    border-radius: 2px;
    background-color: #fff;
    padding: 32px 31px;
    box-sizing: border-box;
  }
  .tel,.password {
    width: 363px;
  }
  .code {
    width: 242px;
  }
  .codeBox {
    position: relative;
  }
  .imgcode {
    cursor: pointer;
  }
  .imgcode,.numcode ,.dis_numcode{
    width: 112px;
    height: 50px;
    position: absolute;
    right: 0;
    top:0;
    border-radius: 2px;
  }
  .dis_numcode{
    text-align: center;
    line-height: 40px;
    background-color: #ccc;
  }
  .numcode {
    background-color: #EA4C51 ;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .haveRegister {
    font-size: 14px;
    color: #909399;
    text-align: center;
    margin-top: 10px;
  }
  .small_login {
    color: #EA4C51;
    cursor: pointer;
  }
  .login_btn {
    width: 363px;
    height: 50px;
    text-align: center;
    color: #fff;
    cursor: pointer;
   font-size: 16px;
    margin-top: 15px;
    background-color: #6435E8;
  }
  .forget {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    color: #666;
    margin-top: 20px;
  }
  .forget_l {
    color: #666;
    cursor: pointer;
  }
  .tipsImg {
    display: inline-block;
    width:16px;
    height: 16px;
    text-align: center;
    line-height: 15px;
    border-radius: 50%;
    background: #FA5555;
    color: #fff;
    vertical-align: middle;
    margin: 0 10px;
  }
  .tipsBox {
    width: 300px;
    height: 32px;
    background: #FEF2F2;
    border: 1px solid #F56C6C;
    border-radius: 4px;
    color: #F56C6C;
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 15px;
  }
</style>
 
<style >
.xingluo-components-page-bottom-reserve-icon{
  width: 24px;
  vertical-align: middle;
  margin-right: 5px;
}

</style>
